import { render, staticRenderFns } from "./QuarterSwitchItem.vue?vue&type=template&id=2a70d53c&scoped=true&"
import script from "./QuarterSwitchItem.vue?vue&type=script&lang=ts&"
export * from "./QuarterSwitchItem.vue?vue&type=script&lang=ts&"
import style0 from "./QuarterSwitchItem.vue?vue&type=style&index=0&id=2a70d53c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a70d53c",
  null
  
)

export default component.exports